module.exports = __webpack_public_path__ + "static/media/MZ.3a028fbe.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/country-flags/MZ.svg
// module id = 2221
// module chunks = 7